export default __webpack_public_path__ + "static/media/temperature.c80ffbb9.png";